import { Injectable, signal } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { catchError, finalize, map, Observable, shareReplay, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class AuthService {
    public readonly isAuthenticated = signal<boolean | null>(null);
    private initAuth$?: Observable<boolean>;

    constructor(private readonly oidcSecurityService: OidcSecurityService) {}

    public initAuth(): Observable<boolean> {
        if (this.initAuth$) {
            return this.initAuth$;
        }

        if (!environment.auth.isConfigured) {
            this.isAuthenticated.set(false);
            return throwError(
                () =>
                    new Error(
                        'Supplier authentication is not configured. Set auth.authority and auth.clientId in the environment file.'
                    )
            );
        }

        this.initAuth$ = this.oidcSecurityService.checkAuth(window.location.href).pipe(
            map((result) => {
                this.isAuthenticated.set(result.isAuthenticated);

                if (!result.isAuthenticated) {
                    this.login();
                }

                return result.isAuthenticated;
            }),
            catchError((error) => {
                console.error('Authentication initialization failed', error);
                this.isAuthenticated.set(false);
                return throwError(() => error);
            }),
            finalize(() => {
                this.initAuth$ = undefined;
            }),
            shareReplay(1)
        );

        return this.initAuth$;
    }

    public login(): void {
        if (!environment.auth.isConfigured) {
            console.error('Supplier authentication is not configured.');
            return;
        }

        this.oidcSecurityService.authorize();
    }

    public logout(): void {
        this.isAuthenticated.set(false);
        this.oidcSecurityService.logoff().subscribe({
            error: (error) => {
                console.error('Logout failed', error);
            }
        });
    }
}
